
export default function ImageSection() {
  return (
    <section className='min-h-screen w-full bg-cover bg-signImage bg-center bg-no-repeat overflow-hidden'></section>
  );
}
